/** Import modules */

import { useParams, useNavigate }   from "react-router-dom";

import { useTranslation }           from "react-i18next";

/** Import datasets */

import { SortingOptions }           from "../../../../../Datasets/Products";

/** Import components */

import SearchableSelect             from "../../../../Shared/SearchableSelect";

/** Import hooks */

import { RimsNavigator }            from "../../../../../Hooks/RimsNavigator";

/**
 * 
 * @param { attributes } param0 
 * 
 * @returns Product sorting component
 * 
 */

const Sorting = ( { attributes } ) => { const 

    { t }               = useTranslation    (),

    navigate            = useNavigate       (),

    { parameters }      = useParams         (),

    selected            = new URLSearchParams ( parameters ).get ( "sort" ) || "default",
    
    Sort = value => { const 

        object = { f : 12, l : null, b : null, a : null, 
            
            sort: ( value === "default" ) ? null : value };

        return navigate ( `/shop/rims/${
            
            new URLSearchParams ( RimsNavigator ( parameters, object ) ).toString () }` );

    }

    /** Return component */

    return ( <div className="sort">

        <span>
            
            { t ( "sort_by" ) }
            
        </span>

        <label className="select shadow-select">

            <SearchableSelect
                options={ SortingOptions ().filter ( o => o.value !== "default" ).map ( o => ( { text: o.name, value: o.value } ) ) }
                value={ selected }
                onChange={ Sort }
                label={ t ( "sort_by" ) }
            />

        </label>

    </div> );

}

/** Export component */
 
export default Sorting;